import qs from "qs";
import useSWR, { SWRConfiguration } from "swr";

import { isRegionEntitlementDeniedError } from "./errors";
import { fetcher } from "./fetcher";

export type QueryParams = Record<string, unknown>;

export const useAPI = <Data extends unknown>(
  path: string | null,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  const url = path
    ? path +
      qs.stringify(query, { addQueryPrefix: true, arrayFormat: "repeat" })
    : null;

  const shouldRetryOnError: SWRConfiguration["shouldRetryOnError"] = (
    error
  ) => {
    if (isRegionEntitlementDeniedError(error)) {
      return false;
    }

    const userShouldRetry = options?.shouldRetryOnError;
    if (typeof userShouldRetry === "function") {
      return userShouldRetry(error);
    }

    return userShouldRetry ?? true;
  };

  return useSWR<Data>(url, fetcher.request, {
    ...options,
    shouldRetryOnError,
  });
};
